import { render, staticRenderFns } from "./CalendarForm.vue?vue&type=template&id=0f13a56e&scoped=true"
import script from "./CalendarForm.vue?vue&type=script&lang=js"
export * from "./CalendarForm.vue?vue&type=script&lang=js"
import style0 from "./CalendarForm.vue?vue&type=style&index=0&id=0f13a56e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f13a56e",
  null
  
)

export default component.exports